// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../css-loader/index.js!../sass-loader/index.js!./font-awesome-sass-styles.loader.js!./font-awesome-sass.config.js");
if(typeof content === 'string') content = [[module.id, content, '']];
// add the styles to the DOM
var update = require("!../style-loader/addStyles.js")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(module.hot) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../css-loader/index.js!../sass-loader/index.js!./font-awesome-sass-styles.loader.js!./font-awesome-sass.config.js", function() {
			var newContent = require("!!../css-loader/index.js!../sass-loader/index.js!./font-awesome-sass-styles.loader.js!./font-awesome-sass.config.js");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}


//////////////////
// WEBPACK FOOTER
// ./~/style-loader!./~/css-loader!./~/sass-loader!./~/font-awesome-sass-loader/font-awesome-sass-styles.loader.js!./~/font-awesome-sass-loader/font-awesome-sass.config.js
// module id = 280
// module chunks = 2